<template>
    <div>
        <ValidationObserver ref="formModalValidate">
            <b-row v-if="formData">
                <b-col cols="12">
                    <ValidationProvider name="coop_cv_name" rules="required" v-slot="{valid, errors}">
                        <b-form-group :label="$t('coop_cv_name')">
                            <b-form-input v-model="formData.name" :state="errors[0] ? false : null" />
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" class="mb-2"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>

                <b-col cols="12">
                    <b-form-group :label="$t('coop_cv_file')">
                        <div v-if="formData.fileName" class="mb-2 text-muted small">
                            {{ $t('current_file') || 'Mevcut Dosya' }}: <strong>{{ formData.fileName }}</strong>
                        </div>
                        <b-form-file v-model="newFile" accept=".pdf,.doc,.docx" />
                    </b-form-group>
                </b-col>

                <b-col cols="12">
                    <b-form-group :label="$t('label')">
                        <b-form-select v-model="formData.tags" :options="tagOptions" multiple />
                    </b-form-group>
                </b-col>
            </b-row>
            <div class="d-flex justify-content-center mt-3">
                <b-button variant="primary" :disabled="formLoading" @click="updateForm">
                    {{ $t('save') }}
                </b-button>
            </div>
        </ValidationObserver>
    </div>
</template>

<script>
    import { ValidationObserver, ValidationProvider } from 'vee-validate';
    import CoopCvService from '@/services/CoopCvService';

    export default {
        components: {
            ValidationProvider,
            ValidationObserver
        },
        props: {
            formId: {
                type: [Number, String],
                required: true
            }
        },
        data() {
            return {
                formLoading: false,
                formData: null,
                newFile: null,
                tagOptions: [
                    { value: 'tr', text: 'Türkçe' },
                    { value: 'en', text: 'İngilizce' },
                    { value: 'de', text: 'Almanca' },
                    { value: 'fr', text: 'Fransızca' }
                ]
            };
        },
        created() {
            this.getCV();
        },
        methods: {
            getCV() {
                CoopCvService.get(this.formId).then(response => {
                    this.formData = response.data.data;
                });
            },
            async updateForm() {
                const isValid = await this.$refs.formModalValidate.validate();

                if (isValid) {
                    this.formLoading = true;

                    const submitData = new FormData();
                    submitData.append('name', this.formData.name);
                    if (this.newFile) {
                        submitData.append('file', this.newFile);
                    }
                    submitData.append('tags', JSON.stringify(this.formData.tags));

                    CoopCvService.update(this.formId, submitData)
                        .then(response => {
                            this.$toast.success(this.$t(response.data.message) || this.$t('successfully_updated'));
                            this.$emit('actionSuccess', true);
                        })
                        .catch((error) => {
                            if (this.showErrors) {
                                this.showErrors(error, this.$refs.formModalValidate);
                            } else {
                                this.$toast.error(error.message || 'Hata oluştu');
                            }
                        })
                        .finally(() => {
                            this.formLoading = false;
                        });
                }
            }
        }
    };
</script>
